import type { AxiosInstance } from "axios";
import { apiClient } from "@/marketing/infrastructure/http/httpClient";
import { pathSegment } from "@/marketing/lib/pathSegment";
import type {
  CampaignCreatorScoreResponse,
  CampaignCreatorScoresResponse,
} from "@/marketing/models/creatorScore";

const BASE_PATH = "/influencer/campaigns";

export class CreatorScoreAPIClient {
  constructor(private readonly client: AxiosInstance = apiClient) {}

  public async listCampaignScores(
    campaignId: string,
    signal?: AbortSignal,
  ): Promise<CampaignCreatorScoresResponse> {
    const { data } = await this.client.get<CampaignCreatorScoresResponse>(
      `${BASE_PATH}/${pathSegment(campaignId)}/creatorScores`,
      { ...(signal ? { signal } : {}) },
    );
    return data;
  }

  public async getCampaignCreatorScore(
    campaignId: string,
    influencerId: string,
  ): Promise<CampaignCreatorScoreResponse> {
    const { data } = await this.client.get<CampaignCreatorScoreResponse>(
      `${BASE_PATH}/${pathSegment(campaignId)}/influencers/${pathSegment(influencerId)}/creatorScore`,
    );
    return data;
  }
}

export const creatorScoreAPIClient = new CreatorScoreAPIClient();
